var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11287 12.0603L0.143021 18.0301L6.11287 24L7.8182 22.2947L3.76111 18.0304L7.8182 13.7656L6.11287 12.0603ZM15.8817 0L14.1764 1.70533L18.2335 5.97008L14.1764 10.2344L15.8817 11.9397L21.8516 5.96985L15.8817 0Z",
    fill: "#002856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/sections.80e6fb0780cb4980d0cc138b079b3e68.svg";
export { ForwardRef as ReactComponent };